import { defineComponent as b, useCssModule as u, computed as n, createElementBlock as f, openBlock as C, normalizeClass as r, unref as s, createElementVNode as t, renderSlot as i } from "vue";
import { responsiveModifyClass as g } from "../../utils/buildClass.mjs";
import $ from "../../props/background.mjs";
import v from "../../utils/mapClasses.mjs";
const c = "cdr-label-wrapper", _ = /* @__PURE__ */ b({
  name: "CdrLabelWrapper",
  __name: "CdrLabelWrapper",
  props: {
    labelClass: String,
    contentClass: String,
    background: $,
    disabled: Boolean,
    modifier: String,
    size: String
  },
  setup(a) {
    const e = a, l = u(), d = n(() => e.modifier ? `${c}--${e.modifier}` : ""), p = n(() => e.size ? g(c, "", e.size) : ""), m = n(() => e.disabled ? `${c}--disabled` : "");
    return (o, w) => (C(), f("div", {
      class: r(s(l)["cdr-label-wrapper__container"])
    }, [t("label", {
      class: r(s(v)(s(l), "cdr-label-wrapper", `cdr-label-wrapper--${a.background}`, m.value, d.value, p.value).concat(` ${a.labelClass || ""}`))
    }, [i(o.$slots, "input"), t("span", {
      class: r(s(l)["cdr-label-wrapper__figure"])
    }, null, 2), i(o.$slots, "svgs"), t("span", {
      class: r([s(l)["cdr-label-wrapper__content"], a.contentClass])
    }, [i(o.$slots, "default")], 2)], 2)], 2));
  }
});
export {
  _ as default
};
